import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16_9666)">
      <path
        d="M15 13H13V15H5V7H7V5H15V13ZM6 14H12V8H6V14ZM8 7H13V12H14V6H8V7Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0_16_9666">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SVGComponent;
